import React from "react";

//UI Material
import {
  Card,
  Chip,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

//Material Icons
import { Discount } from "@mui/icons-material";

//Local components
import ElementCard from "../../ProComponents/ElementCard";

export default function QuoteProductsTable({ data }) {
  return (
    <Card
      raised
      sx={{
        padding: 2,
      }}
    >
      <Grid container>
        <Grid item xs={12} align="left">
          <ElementCard
            ops={{
              title: "Productos",
              details: [`${data.products.length} registrados`],
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TableContainer>
            <Table aria-label="quote-products-table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">
                    <Typography fontWeight="bold">Cantidad</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography fontWeight="bold">Nombre</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography fontWeight="bold">Detalles</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography fontWeight="bold">Subtotal</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography fontWeight="bold">Descuento</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography fontWeight="bold">IVA</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography fontWeight="bold">Total</Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.products.map((p) => (
                  <TableRow key={p.id}>
                    <TableCell align="center">
                      <Typography>{p.quantity}</Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography>{p.productName}</Typography>
                    </TableCell>
                    <TableCell align="center" sx={{ maxWidth: "200px" }}>
                      <Typography>{p.specifications}</Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography>{`${
                        data.billing.currency === "USD" ? "$" : "₡"
                      }${Number(p.price).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`}</Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Chip
                        icon={<Discount />}
                        label={`${p.discountPercentage}%`}
                        color="warning"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Typography>{`${
                        data.billing.currency === "USD" ? "$" : "₡"
                      }${Number(
                        (p.price * data.billing.taxesPercentage) / 100
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`}</Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography>{`${
                        data.billing.currency === "USD" ? "$" : "₡"
                      }${Number(
                        Number(p.price) +
                          Number(p.price * data.billing.taxesPercentage) / 100
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`}</Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Card>
  );
}
